import { useDispatch } from 'react-redux'
import { useCallback, useState } from 'react'
import Dialog from '../../atoms/feedback/Dialog'
import Label from '../../atoms/display/Label'
import FormItem from '../../molecules/inputs/FormItem'
import TextField from '../../atoms/inputs/TextField'
import { FlexRow } from '../../atoms/layout/Flex'
import Button from '../../atoms/inputs/Button'
import { CompanyActions } from '../../../store/company'
import { CompanyRepresentative } from '../../../types/Company'

type Props = {
  open: boolean
  representative: CompanyRepresentative
  onClose: () => void
}

export default function CompanyRepresentativeRejectDialog({ open, representative, onClose }: Props) {
  const [reason, setReason] = useState<string | undefined>()
  const dispatch = useDispatch()

  const handleReject = useCallback(() => {
    if (reason) {
      dispatch(
        CompanyActions.rejectRepresentative({
          companyId: representative.company.id,
          representativeId: representative.id,
          reason,
        })
      )
      onClose()
    }
  }, [dispatch, onClose, reason, representative])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="本人確認の差し戻し"
      actions={
        <FlexRow>
          <Button variant="text" onClick={onClose}>
            キャンセル
          </Button>
          <Button color="caution" disabled={!reason} onClick={handleReject}>
            差し戻し
          </Button>
        </FlexRow>
      }
    >
      <Label text="本人確認を差し戻しますか？" />
      <FormItem label="差し戻し理由">
        <TextField multiline rows={5} onChange={setReason} />
      </FormItem>
    </Dialog>
  )
}
